const ACTIVE_SUB_STATUSES = ['active', 'trialing', 'past_due', 'cancel_at_period_end'];

export function hasActiveStripeSub(org: {
  stripe_subscription_id?: string | null;
  stripe_subscription_status?: string | null;
} | null | undefined): boolean {
  if (!org?.stripe_subscription_id) return false;
  return ACTIVE_SUB_STATUSES.includes(org.stripe_subscription_status || '');
}

/**
 * Admin or finance without an active subscription must stay on /assinar
 * until Stripe confirms a plan. Employees (invited) are not gated here.
 */
export function needsPlanCheckout(
  role: string | null | undefined,
  org: {
    stripe_subscription_id?: string | null;
    stripe_subscription_status?: string | null;
  } | null | undefined,
): boolean {
  if (role !== 'admin' && role !== 'fin_ops') return false;
  return !hasActiveStripeSub(org);
}
